import { Badge, ListItemButton, ListItemIcon, useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import colorConfigs from "../configs/colorConfigs";
import { RootState } from "../redux/store";
import { RouteType } from "../routes/config";
import checkRoutePermissions from "../routes/appRoutePermissions";


type Props = {
  item: RouteType;
  isHovered: boolean;
};

const SidebarItem = ({ item, isHovered }: Props) => {
  const { appState } = useSelector((state: RootState) => state.appState);
  const authData = useSelector((state: RootState) => state.auth);
  const permission = checkRoutePermissions(authData, item);
  const isMobile = useMediaQuery('(max-width:768px)');

  if (isMobile) {
    isHovered = true
  }
  if (!permission) return null; // Do not render if the route is not visible
  
  return (
    item.sidebarProps && item.path ? (
      <ListItemButton data-testid="ListItemButton-b4s6"
        component={Link}
        to={permission !== 'premium' ? item.path : '#'} // Disable link for premium routes
        disableRipple
        selected={appState === item.state}
        sx={{
          "&:hover": {
            color: permission === 'premium' ? 'grey' : colorConfigs.sidebar.activeBg,
            cursor: permission === 'premium' ? 'not-allowed' : 'pointer',
            backgroundColor: colorConfigs.sidebar.bg,
            // Apply hover effect to the icon inside ListItemButton
            "& .MuiListItemIcon-root": {
            color: permission === "premium" ? "grey" : colorConfigs.sidebar.activeBg,
          },
          },
          "&.Mui-selected": {
            backgroundColor: colorConfigs.sidebar.bg,
            color: colorConfigs.sidebar.activeBg,
            "&:hover": {
              backgroundColor: colorConfigs.sidebar.bg,
            },
            "&:focus": {
              backgroundColor: colorConfigs.sidebar.bg,
            },
            "&:active": {
              backgroundColor: colorConfigs.sidebar.bg,
            },
          },
          "&.Mui-selected.Mui-focusVisible": {
            backgroundColor: colorConfigs.sidebar.bg,
          },
          "&.Mui-selected:active": {
            backgroundColor: colorConfigs.sidebar.bg,
          },
          "&.Mui-selected:focus": {
            backgroundColor: colorConfigs.sidebar.bg,
          },
          color: permission === 'premium' ? 'grey' : appState === item.state ? colorConfigs.sidebar.activeBg : colorConfigs.sidebar.color,
          paddingY: isMobile ? 0 : "10px",
          opacity: permission === 'premium' ? 0.65 : 1,
          position: 'relative', // Required for Badge
        }}
      >
        <ListItemIcon data-testid="ListItemIcon-e5oc" sx={{
          minWidth: "unset",
          marginLeft: "7px",
          p:0,
          marginRight: "20px",
          justifyContent: "center",
          transition: "margin-right 0.3s",
          color: permission === 'premium' ? 'grey' : appState === item.state ? colorConfigs.sidebar.activeBg : colorConfigs.sidebar.color,  // Keep the displayText color as is
          "&:hover": {
            color: permission === 'premium' 
            ? 'grey' 
            : colorConfigs.sidebar.activeBg,            
            backgroundColor: colorConfigs.sidebar.bg,
          },
          "&.Mui-selected": {
            backgroundColor: colorConfigs.sidebar.bg,
            color: colorConfigs.sidebar.activeBg,
            "&:hover": {
              backgroundColor: colorConfigs.sidebar.bg,
            },
            "&:focus": {
              backgroundColor: colorConfigs.sidebar.bg,
            },
            "&:active": {
              backgroundColor: colorConfigs.sidebar.bg,
            },
          },
          "&.Mui-selected.Mui-focusVisible": {
            backgroundColor: colorConfigs.sidebar.bg,
          },
          "&.Mui-selected:active": {
            backgroundColor: colorConfigs.sidebar.bg,
          },
          "&.Mui-selected:focus": {
            backgroundColor: colorConfigs.sidebar.bg,
          },
        }}>
          {item.sidebarProps.icon && item.sidebarProps.icon}
        </ListItemIcon>
        {isHovered && (
        <>
          <Badge data-testid="Badge-9nbb"
            sx={{
              '& .MuiBadge-badge': {
                color: 'unset',
                backgroundColor: 'transparent',
                borderRadius: '12px',
                fontWeight: 'bold',
                paddingX: 0.5,
                paddingY: 0,
                fontSize: '0.5rem',
                height: "55%",
                right: '5px',
                top: '-1.5px',
                cursor: 'pointer',
                },
              color: permission === 'premium' ? 'grey' : appState === item.state ? 'unset' : "unset",
            }}
            badgeContent={
              permission === 'premium' ? (
                <Link
                  to="/account/subscription"
                  style={{ textDecoration: 'none', color: '#111', padding:0, margin:0}}
                >
                  Premium
                </Link>
              ) : null
            }
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            {item.sidebarProps.displayText}
          </Badge>
        </>
      )}
      </ListItemButton>
    ) : null
  );
};

export default SidebarItem;